/* eslint-disable */

export const state = {}
export const mutations = {}
export const actions = {}

export default {
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/vuex/modules/subWallets.module.js